<template>
  <div class="users">
    <!-- HEADER WITH SWITCH AND NEW USER BUTTON -->
    <div class="users-header">
      <div class="user-types">
        <span
          class="user-type"
          :class="{ 'user-type-active': userType === '' }"
          @click="userType = ''"
          title="Всички потребители, без изпълнителите и освободените"
          >всички потребители</span
        >
        <span
          class="user-type"
          :class="{ 'user-type-active': userType === 'isUnit' }"
          @click="userType = 'isUnit'"
          title="Звена"
          >Звена</span
        >
        <span
          class="user-type"
          :class="{ 'user-type-active': userType === 'isWorker' }"
          @click="userType = 'isWorker'"
          title="Всички доставчици и контрагенти"
          >изпълнители</span
        >
        <span
          class="user-type"
          :class="{ 'user-type-active': userType === 'isReleased' }"
          @click="userType = 'isReleased'"
          title="Служители, които са освободени"
          >освободени</span
        >
      </div>

      <TheInput
        v-if="
          userType !== 'isUnit' &&
          userType !== 'isWorker' &&
          userType !== 'isReleased'
        "
        class="user-role-filter"
        :list="userTypeList"
        prop="name"
        propValue="value"
        placeholder="Филтрирай по роля"
        v-model="userType"
        @clear="userType = ''"
        @input="userType = $event.value"
      />
      <!-- NEW USER BUTTON -->
      <template
        v-if="
          getUser.permissions.isSuperAdmin ||
          getUser.permissions.isAdmin ||
          getUser.permissions.isHR
        "
      >
        <input
          ref="leaveImportInput"
          class="leave-import-input"
          type="file"
          accept=".xls,.xlsx"
          @change="handleLeaveImport"
        />
        <button
          class="btn btn-excel desktop"
          :disabled="isImportingLeave"
          @click="triggerLeaveImport"
        >
          {{ isImportingLeave ? "Обработка..." : "Импорт отпуски" }}
        </button>
        <button
          class="btn btn-excel mobile leave-import-mobile"
          :disabled="isImportingLeave"
          @click="triggerLeaveImport"
        >
          {{ isImportingLeave ? "Обработка..." : "Импорт отпуски" }}
        </button>
        <transition name="slide-right-and-fade" mode="out-in">
          <button
            v-if="userType === 'isUnit'"
            class="btn btn-new desktop"
            @click="showUnitModal = true"
          >
            <span class="sienit">V</span>
            Ново звено
          </button>

          <template v-else>
            <button
              class="btn btn-new desktop"
              v-if="!showNewBtns"
              @click="showNewBtns = true"
            >
              <span class="sienit">V</span>
              Нов
            </button>
            <div class="btns" v-else>
              <button
                class="btn btn-new btn-blue desktop"
                @click="isUserModalOpened = 'employee'"
              >
                <span class="sienit">V</span>
                Нов служител
              </button>
              <button
                class="btn btn-new btn-green desktop"
                @click="isUserModalOpened = 'worker'"
              >
                <span class="sienit">V</span>
                Нов изпълнител
              </button>
            </div>
          </template>
        </transition>
      </template>
    </div>
    <!-- DESKTOP TABLE WITH USERS (ACTIVE AND INACTIVE) -->
    <div class="table-wrapper desktop">
      <table class="table">
        <tbody>
          <tr
            v-for="user of searchFilter()"
            :key="user._id"
            :class="{ 'inactive-row': !user.isActive }"
            @click="editField(user)"
          >
            <td class="td-user-name">
              <span class="sienit">B</span>
              <span>
                <strong>{{ user.name }}</strong>
              </span>
            </td>
            <td>
              <template v-if="!user.permissions.isWorker">{{
                user.username
              }}</template>
            </td>
            <td v-if="!user.permissions.isWorker">{{ user.email }}</td>
            <td v-if="!user.permissions.isWorker">{{ user.phone }}</td>
            <td>
              <template v-for="role in userTypeList">
                <span
                  v-if="user.permissions[role.value]"
                  :key="role.value"
                  class="permission-indicator"
                  :class="`${role.value}-indicator`"
                >
                  {{ role.shortName || role.name }}
                </span>
              </template>
            </td>
          </tr>
        </tbody>
        <tbody v-if="userType === 'isUnit'">
          <tr
            v-for="unit in units"
            :key="unit._id"
            :class="{ 'inactive-row': !unit.isActive }"
            @click="editField(unit, true)"
          >
            <td>{{ unit.name }}</td>
            <td>
              <div v-if="unit.workers">
                <p v-for="w of unit.workers" :key="w._id">{{ w.name }}</p>
              </div>
            </td>
          </tr>
          <tr v-if="!units.length">
            <td colspan="2" class="center">Няма създадени звена</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- MOBILE TABLE WITH USERS (ACTIVE AND INACTIVE) -->
    <div class="table-wrapper mobile">
      <table class="table">
        <tbody>
          <tr
            v-for="user of searchFilter()"
            :key="user._id"
            :class="{ 'inactive-row': !showActiveUsers }"
            @click="editField(user)"
          >
            <td class="td-user-name">
              <div class="user-mobile">
                <span>
                  <strong>{{ user.name }}</strong>
                </span>
              </div>
              <div class="user-permissions">
                <template v-for="role in userTypeList">
                  <span
                    v-if="user.permissions[role.value]"
                    :key="role.value"
                    class="permission-indicator"
                    :class="`${role.value}-indicator`"
                  >
                    {{ role.shortName || role.name }}
                  </span>
                </template>
                <span
                  v-if="user.permissions.isTechLead"
                  class="permission-indicator isTechLead-indicator"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 18.75 15"
                  >
                    <g id="Layer_2" data-name="Layer 2">
                      <g id="Layer_1-2" data-name="Layer 1">
                        <path
                          id="Path_7187"
                          data-name="Path 7187"
                          class="cls-1"
                          d="M15.25,3.75l.61,0q.36,0,.75,0a6.69,6.69,0,0,1,.77,0,2.14,2.14,0,0,1,.69.18,1.29,1.29,0,0,1,.49.41,1.18,1.18,0,0,1,.19.69v8.75a1.38,1.38,0,0,1-.1.49,1.27,1.27,0,0,1-.67.67,1.32,1.32,0,0,1-.48.09H1.25a1.19,1.19,0,0,1-.49-.1,1.18,1.18,0,0,1-.4-.27,1.41,1.41,0,0,1-.27-.4A1.28,1.28,0,0,1,0,13.75V5a1.19,1.19,0,0,1,.1-.49,1.18,1.18,0,0,1,.27-.4,1.41,1.41,0,0,1,.4-.27,1.34,1.34,0,0,1,.49-.1h8.5L12.93.57a2.08,2.08,0,0,1,.63-.43A2.11,2.11,0,0,1,14.3,0a1.74,1.74,0,0,1,.75.16,2,2,0,0,1,.62.42,1.94,1.94,0,0,1,.42.62,1.9,1.9,0,0,1,.15.75,1.86,1.86,0,0,1-.07.57A2.48,2.48,0,0,1,16,3a3.12,3.12,0,0,1-.32.4Zm-.95-2.5a.65.65,0,0,0-.49.21l-8,8-.33,1.32,1.32-.33,6.65-6.64s0,0,0-.05a0,0,0,0,1,0,0c.08-.08.2-.19.37-.33s.34-.3.51-.47a4.23,4.23,0,0,0,.44-.51A.81.81,0,0,0,15,2a.64.64,0,0,0-.21-.5.66.66,0,0,0-.48-.2ZM17.5,5H14L7.43,11.58l-3.68.92.92-3.68L8.5,5H1.25v8.75H17.5Z"
                        />
                      </g>
                    </g>
                  </svg>
                </span>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="userType === 'isUnit'">
          <tr
            v-for="unit in units"
            :key="unit._id"
            :class="{ 'inactive-row': !unit.isActive }"
            @click="editField(unit, true)"
          >
            <td>{{ unit.name }}</td>
            <td>workers</td>
          </tr>
          <tr v-if="!units.length">
            <td colspan="2" class="center">Няма създадени звена</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- BUTTON NEW USER FOR MOBILE -->
    <footer class="modal-footer mobile">
      <transition name="slide-right-and-fade" mode="out-in">
        <div
          v-if="!showNewBtns"
          class="new-content-data-item-toggle-circle mobile"
          @click="
            userType === 'isUnit'
              ? (showUnitModal = true)
              : (showNewBtns = true)
          "
        >
          <span class="sienit">V</span>
        </div>
        <div v-else>
          <div
            class="new-content-data-item-toggle-circle btn-blue mobile"
            @click="isUserModalOpened = 'employee'"
          >
            <span class="sienit">V</span>
          </div>
          <div
            class="new-content-data-item-toggle-circle new-content-data-item-toggle-circle-2 btn-green mobile"
            @click="isUserModalOpened = 'worker'"
          >
            <span class="sienit">V</span>
          </div>
        </div>
      </transition>
    </footer>
    <!-- USER MODAL -->
    <transition name="fade">
      <appUserModal
        v-if="isUserModalOpened"
        :idToEdit="idToEdit"
        :userMode="isUserModalOpened === 'employee' ? true : false"
      />
    </transition>
    <!-- UNIT MODAL -->
    <transition name="fade">
      <UnitModal
        v-if="showUnitModal"
        :idToEdit="idToEdit"
        @close="closeUnitsModal"
      />
    </transition>
    <Modal
      v-if="leaveImportPreview"
      classes="medium leave-import-modal"
      @close="closeLeaveImport"
    >
      <header>
        <p>Импорт на платен отпуск</p>
        <button
          class="modal__close"
          type="button"
          aria-label="Затвори"
          @click="closeLeaveImport"
        >
          <svg aria-hidden="true" viewBox="0 0 16 16">
            <path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" />
          </svg>
        </button>
      </header>
      <main>
        <p v-if="leaveImportPreview.changes.length" class="leave-import-summary">
          Ще се променят дните платен отпуск на
          {{ leaveImportPreview.changes.length }}
          {{ leaveImportPreview.changes.length === 1 ? "служител" : "служители" }}:
        </p>
        <p
          v-else-if="leaveImportPreview.skipped.length"
          class="leave-import-summary"
        >
          Няма данни за потвърждение. Проверете пропуснатите записи.
        </p>
        <p v-else class="leave-import-summary">
          Данните за платен отпуск са актуални.
        </p>

        <div v-if="leaveImportPreview.changes.length" class="leave-import-table-wrapper">
          <table class="leave-import-table">
            <thead>
              <tr>
                <th>Служител</th>
                <th>Промени</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="change in leaveImportPreview.changes" :key="change.userId">
                <td>{{ change.name }}</td>
                <td>
                  <div v-for="year in change.years" :key="year.year">
                    {{ year.year }}:
                    {{ year.current === null ? "няма стойност" : year.current }}
                    → {{ year.imported }} дни
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <section v-if="leaveImportPreview.skipped.length" class="leave-import-skipped">
          <h4>Пропуснати записи</h4>
          <p v-for="item in leaveImportPreview.skipped" :key="`${item.name}-${item.reason}`">
            <strong>{{ item.name }}</strong>: {{ item.reason }}
          </p>
        </section>
      </main>
      <footer>
        <span></span>
        <div class="btns">
          <button
            v-if="leaveImportPreview.changes.length"
            class="btn btn-new"
            type="button"
            :disabled="isImportingLeave"
            @click="confirmLeaveImport"
          >
            {{ isImportingLeave ? "Запазване..." : "Потвърждение" }}
          </button>
          <button
            class="btn btn-close"
            type="button"
            :disabled="isImportingLeave"
            @click="closeLeaveImport"
          >
            {{ leaveImportPreview.changes.length ? "Отказ" : "Затвори" }}
          </button>
        </div>
      </footer>
    </Modal>
  </div>
</template>

<script>
import XLSX from "xlsx";
import UserModal from "./shared/UserModal";
import UnitModal from "./shared/UnitModal";
import { mapGetters } from "vuex";
import TheInput from "./shared/TheInput.vue";
import Modal from "./components/Modal.vue";
export default {
  components: {
    appUserModal: UserModal,
    UnitModal,
    TheInput,
    Modal,
  },
  data() {
    return {
      userType: "",
      showUnitModal: false,
      showUsers: false,
      showNewBtns: false,
      showActiveUsers: true,
      isUserModalOpened: "",
      idToEdit: "",
      users: [],
      units: [],
      search: "",
      isImportingLeave: false,
      leaveImportRows: [],
      leaveImportPreview: null,
      userTypeList: [
        { name: "Главен администратор", value: "isSuperAdmin", shortName: "J" },
        { name: "Администратор", value: "isAdmin" },
        { name: "Отчетник", value: "isReporter" },
        { type: "divider" },
        { name: "Изпълнителен директор", value: "isCEO", shortName: "ИД" },
        { name: "Човешки ресурси", value: "isHR", shortName: "ЧР" },
        {
          name: "Ръководител Отпуски",
          value: "isTechLead",
          shortName: "РО",
        },
        {
          name: "Ръководител всички отпуски",
          value: "isLeadAll",
          shortName: "РВО",
        },
        {
          name: "Административен персонал",
          value: "isAdministrativeStaff",
          shortName: "Админ. персонал",
        },
        { name: "Работник", value: "isStaff" },
        { type: "divider" },
        { name: "Счетоводител", value: "isAccountant" },
        {
          name: "Ръководител всички обекти",
          value: "isAllObjectsManager",
          shortName: "Рък-л вс. обекти",
        },
        {
          name: "Ръководител проект",
          value: "isProjectManager",
          shortName: "Рък-л проект",
        },
        {
          name: "Главен отчетник",
          value: "isAllProjectsManager",
          shortName: "Гл. отчетник",
        },
        { name: "Отчетник Обект", value: "isObjectManager" },
        {
          name: "Отчетник всички обекти",
          value: "isAllProjectsReporter",
          shortName: "Отчетник вс. обекти",
        },
      ],
    };
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    // Filtered by active
    filteredUsers() {
      if (this.userType === "noPermissions") {
        return this.users.filter((u) => {
          if (
            !u.permissions.isSuperAdmin &&
            !u.permissions.isAdmin &&
            !u.permissions.isWorker &&
            !u.permissions.isReporter &&
            !u.permissions.isHR &&
            !u.permissions.isCEO &&
            !u.permissions.isTechLead &&
            !u.isReleased
          ) {
            return true;
          } else {
            return false;
          }
        });
      }
      if (this.userType === "allAdmins") {
        return this.users.filter((u) => {
          if (
            (u.permissions.isSuperAdmin ||
              u.permissions.isAdmin ||
              u.permissions.isCEO) &&
            !u.isReleased
          ) {
            return true;
          } else {
            return false;
          }
        });
      } else if (this.userType === "isReleased") {
        return this.users.filter((u) => {
          return u.isReleased;
        });
      } else if (this.userType.length) {
        return this.users.filter((u) => {
          return u.permissions[this.userType] === true && !u.isReleased;
        });
      } else {
        return this.users.filter((u) => {
          return u.permissions.isWorker === false && !u.isReleased;
        });
      }
    },
  },
  methods: {
    triggerLeaveImport() {
      this.$refs.leaveImportInput.value = "";
      this.$refs.leaveImportInput.click();
    },
    handleLeaveImport(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      this.isImportingLeave = true;

      reader.onload = ({ target }) => {
        try {
          this.leaveImportRows = this.parseLeaveWorkbook(target.result);
          this.loadLeaveImportPreview();
        } catch (error) {
          this.isImportingLeave = false;
          this.$snotify.error(error.message);
        }
      };
      reader.onerror = () => {
        this.isImportingLeave = false;
        this.$snotify.error("Файлът не може да бъде прочетен.");
      };
      reader.readAsArrayBuffer(file);
    },
    parseLeaveWorkbook(data) {
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const matrix = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        raw: true,
        defval: null,
      });

      if (!matrix.length || String(matrix[0][0] || "").trim() !== "Име") {
        throw new Error('Първата колона трябва да бъде „Име“.');
      }

      const yearColumns = [];
      matrix[0].forEach((header, index) => {
        if (index === 0 || header === null || String(header).trim() === "") return;

        const match = String(header).trim().match(/^Остатък за (\d{4})$/);
        if (!match) {
          throw new Error(`Непозната колона: ${header}.`);
        }
        if (yearColumns.some((column) => column.year === match[1])) {
          throw new Error(`Годината ${match[1]} се среща повече от веднъж.`);
        }
        yearColumns.push({ index, year: match[1] });
      });

      if (!yearColumns.length) {
        throw new Error("Файлът не съдържа колони с остатък по години.");
      }

      const rows = matrix.slice(1).filter((row) => row.some((value) => value !== null && value !== ""));
      if (!rows.length) {
        throw new Error("Файлът не съдържа служители.");
      }

      return rows.map((row, index) => {
        const name = String(row[0] || "").trim().replace(/\s+/g, " ");
        if (!name) {
          throw new Error(`Липсва име на ред ${index + 2}.`);
        }

        const leave = {};
        yearColumns.forEach((column) => {
          const value = row[column.index];
          if (value === null || value === undefined || String(value).trim() === "") return;

          const days = typeof value === "number"
            ? value
            : Number(String(value).trim().replace(",", "."));
          if (!Number.isFinite(days) || days < 0) {
            throw new Error(`Невалиден брой дни за ${name}, ${column.year}.`);
          }
          leave[column.year] = days;
        });

        return { name, leave };
      });
    },
    loadLeaveImportPreview() {
      this.$http
        .post(`${process.env.VUE_APP_BASE_URI}/auth/users/leave-import`, {
          rows: this.leaveImportRows,
          apply: false,
        })
        .then((response) => {
          this.leaveImportPreview = response.data;
        })
        .catch((error) => {
          this.$snotify.error(
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Файлът не може да бъде обработен."
          );
        })
        .finally(() => {
          this.isImportingLeave = false;
        });
    },
    confirmLeaveImport() {
      this.isImportingLeave = true;
      this.$http
        .post(`${process.env.VUE_APP_BASE_URI}/auth/users/leave-import`, {
          rows: this.leaveImportRows,
          apply: true,
          previewFingerprint: this.leaveImportPreview.previewFingerprint,
        })
        .then((response) => {
          const count = response.data.appliedCount;
          this.isImportingLeave = false;
          this.closeLeaveImport();
          this.$snotify.success(
            `Актуализирани са дните платен отпуск на ${count} ${
              count === 1 ? "служител" : "служители"
            }.`
          );
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            this.leaveImportPreview = error.response.data;
          }
          this.$snotify.error(
            error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : "Промените не могат да бъдат запазени."
          );
        })
        .finally(() => {
          this.isImportingLeave = false;
        });
    },
    closeLeaveImport() {
      if (this.isImportingLeave) return;
      this.leaveImportPreview = null;
      this.leaveImportRows = [];
    },
    // Filter users for searching by name
    searchFilter() {
      let filteredusers = this.filteredUsers;
      return filteredusers.filter((u) => {
        return (
          u.name.toLowerCase().includes(this.search.toLowerCase()) ||
          u.username.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    editField(u, isUnit) {
      if (
        !this.getUser.permissions.isAdmin & !this.getUser.permissions.isHR &&
        !this.getUser.permissions.isCEO
      ) {
        this.$snotify.error("Нямате нужните права да рекатирате потребители.");
        return false;
      }
      if (
        !isUnit &&
        u.permissions.isSuperAdmin &&
        !this.getUser.permissions.isSuperAdmin &&
        !this.getUser.permissions.isHR
      ) {
        this.$snotify.error(
          "Нямате нужните права за редактирането на този потребител!"
        );
        return;
      }
      this.idToEdit = u._id;
      if (isUnit) {
        this.showUnitModal = true;
      } else {
        this.isUserModalOpened = u.permissions.isWorker ? "worker" : "employee";
      }
    },
    getUsers() {
      this.$store.dispatch("startLoading");
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/auth/users`)
        .then((response) => {
          this.users = response.data;
          this.$store.dispatch("stopLoading");
        });
    },
    getUnits() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/units`)
        .then((res) => {
          this.units = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeUnitsModal(update) {
      this.showUnitModal = false;
      this.idToEdit = "";
      if (update) this.getUnits();
    },
  },
  mounted() {
    this.getUsers();
    this.getUnits();

    this.$on("closeUserModal", (result) => {
      this.isUserModalOpened = "";
      this.showNewBtns = false;
      this.idToEdit = "";
      // if result.isEdited = true, this means something is changed and we get the users again
      if (result.isEdited) {
        this.users = [];
        this.getUsers();
      }
    });
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
      // console.log(this.search);
    });
  },
  destroyed() {
    this.$off("closeUserModal");
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped>
.users {
  padding: 10px 40px;
  overflow: hidden;
  width: 100%;
}
.users-header {
  align-items: center;
  display: flex;
  height: 36px;
  justify-content: space-between;
}
.switch-wrapper {
  align-items: center;
  display: flex;
}
.switch {
  margin: 0 10px;
}
.switch .slider {
  background-color: #07a11c;
}
.switch input:checked + .slider {
  background-color: #3b86ff;
}
.switch-label {
  cursor: pointer;
  font-weight: 700;
  opacity: 0.4;
}
.switch-label-active {
  opacity: 1;
}
td {
  width: 25%;
}
.table tr td:last-child {
  white-space: nowrap;
}
.td-user-name span {
  vertical-align: middle;
}
.td-user-name .sienit {
  margin: 0 7px 0 4px;
}
.inactive-row {
  background-color: #fddddd;
}
.inactive-row:hover {
  background-color: #f3c4c4;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}

.user-types {
  display: flex;
  overflow: auto;
  /* flex-wrap: wrap; */
  width: 100%;
}

.user-role-filter {
  flex: 0 0 175px;
}

.user-role-filter::v-deep input {
  padding-right: 34px;
}

.user-type {
  background-color: #b8b8b8;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  margin: 3px 5px 3px 0;
  text-transform: uppercase;
  transition: all 0.3s;
  padding: 9px 12px;
  white-space: nowrap;
}

.user-type-active {
  background-color: #5c2101;
}

.user-type:hover {
  opacity: 0.9;
}

.btn {
  width: initial;
  padding: 0 15px;
  white-space: nowrap;
}

.btn-blue {
  background-color: #03799e;
}

.btn-green {
  background-color: #89aa89;
}

.leave-import-input {
  display: none;
}

.leave-import-summary {
  font-size: 16px;
  padding: 10px 0;
}

.modal__close {
  align-items: center;
  border: 0;
  flex: 0 0 32px;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;
}

.modal__close svg {
  display: block;
  height: 14px;
  width: 14px;
}

.leave-import-table-wrapper {
  flex-shrink: 0;
  max-height: 45vh;
  overflow: auto;
}

.leave-import-table {
  border-collapse: collapse;
  width: 100%;
}

.leave-import-table th,
.leave-import-table td {
  border-bottom: 1px solid #e4edf3;
  padding: 9px;
  text-align: left;
  vertical-align: top;
  width: 50%;
}

.leave-import-table th {
  background-color: #5c2101;
  color: #fff;
  position: sticky;
  top: 0;
}

.leave-import-skipped {
  background-color: #fff4dd;
  border-radius: 4px;
  margin-top: 10px;
  padding: 10px;
}

.leave-import-skipped h4 {
  margin-bottom: 5px;
}

.leave-import-skipped p {
  font-size: 13px;
  margin: 3px 0;
}

.leave-import-mobile {
  justify-content: center;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .users {
    padding: 10px 15px;
  }
  .users-header {
    flex-wrap: wrap;
    height: auto;
    justify-content: center;
  }
  .user-types,
  .user-role-filter {
    flex: 0 0 100%;
  }
  .user-role-filter {
    margin-top: 8px;
  }
  .leave-import-mobile {
    flex: 0 0 100%;
    margin-top: 8px;
  }
  .table-wrapper {
    overflow: auto;
  }
  .user-mobile {
    display: flex;
    justify-content: center;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
  }
  .user-permissions {
    display: flex;
    justify-content: center;
    padding-bottom: 0.5em;
  }
  .new-content-data-item-toggle-circle {
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
  .new-content-data-item-toggle-circle .sienit {
    border-color: transparent;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle-2.mobile {
    bottom: 80px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .modal-footer {
    background-color: #fff;
    height: 75px;
    padding: 0px;
  }
}
</style>
